document.addEventListener("DOMContentLoaded", () => {

  const tabs = document.querySelectorAll(".location-tab");
  const panels = document.querySelectorAll(".location-panel");

  tabs.forEach((tab) => {

    tab.addEventListener("click", () => {

      const location = tab.dataset.location;

      tabs.forEach((item) => item.classList.remove("active"));
      panels.forEach((item) => item.classList.remove("active"));

      tab.classList.add("active");

      document
        .querySelector(`.location-panel[data-location="${location}"]`)
        ?.classList.add("active");

    });

  });


 /* ============================
   Custom Dropdown
============================ */

const dropdown = document.querySelector(".boat-location-dropdown");
const trigger = document.querySelector(".boat-location-trigger");
const selected = document.querySelector(".selected-location");
const options = document.querySelectorAll(".boat-location-option");

if (dropdown && trigger) {

    trigger.addEventListener("click", function () {

        dropdown.classList.toggle("open");

    });

}

options.forEach((option) => {

    option.addEventListener("click", function () {

        const location = this.dataset.location;

        selected.textContent = this.textContent;

        dropdown.classList.remove("open");

        panels.forEach((panel) => {

            panel.classList.remove("active");

        });

        document
            .querySelector(`.location-panel[data-location="${location}"]`)
            ?.classList.add("active");

    });

});

document.addEventListener("click", function (e) {

    if (!dropdown.contains(e.target)) {

        dropdown.classList.remove("open");

    }

});
});